import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";
import { NAV_LINKS, LOGO, openBooking } from "../../lib/site";
import { NewsletterForm } from "./Primitives";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-brand-ink text-brand-cream grain overflow-hidden">
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-10">
        <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <img src={LOGO} alt="Nervani Beauty" className="h-14 w-14 object-contain bg-white rounded-full p-1" />
              <span className="font-serif text-3xl tracking-tight">Nervani Beauty</span>
            </div>
            <p className="text-brand-cream/70 font-light mt-6 max-w-sm leading-relaxed">
              The destination for nail education, salon business coaching, luxury
              foot care, and premium beauty products. Founded by Giouvanna White.
            </p>
            <div className="mt-8">
              <p className="text-[11px] uppercase tracking-[0.3em] text-brand-gold mb-4">Join the list</p>
              <NewsletterForm dark testId="footer-newsletter-form" source="footer" />
            </div>
          </div>

          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-brand-gold mb-6">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
                    className="text-brand-cream/70 hover:text-brand-gold transition-colors font-light"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-brand-gold mb-6">Get Started</p>
            <ul className="space-y-3">
              <li><button data-testid="footer-book-btn" onClick={openBooking} className="text-brand-cream/70 hover:text-brand-gold transition-colors font-light">Book a Service</button></li>
              <li><Link to="/course" className="text-brand-cream/70 hover:text-brand-gold transition-colors font-light">Register for Training</Link></li>
              <li><Link to="/shop" className="text-brand-cream/70 hover:text-brand-gold transition-colors font-light">Shop Products</Link></li>
              <li><Link to="/contact" className="text-brand-cream/70 hover:text-brand-gold transition-colors font-light">Contact Us</Link></li>
            </ul>
            <div className="flex items-center gap-4 mt-8">
              <a href="https://www.instagram.com/nervanibeauty/" target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:border-brand-gold hover:text-brand-gold transition-colors"><Instagram size={17} /></a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:border-brand-gold hover:text-brand-gold transition-colors"><Facebook size={17} /></a>
              <a href="mailto:hello@nervanibeauty.com" data-testid="footer-email" aria-label="Email" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:border-brand-gold hover:text-brand-gold transition-colors"><Mail size={17} /></a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-brand-cream/50 text-xs tracking-wide">
          <p>© {new Date().getFullYear()} Nervani Beauty. All rights reserved.</p>
          <p>Nail Education · Business Coaching · Luxury Foot Wellness · Beauty Products</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
